import { createContext } from 'react';

import { DEFAULT_LABELS_OFFSET, DEFAULT_LABELS_WIDTH } from '../constants.js';

interface AnnotationsContextProps {
  showLabels: boolean;
  labelsWidth: number;
  trackWidth: number;
  /**
   * Draws a separator line below the last (bottom-most) track, closing off the
   * markers band. Used by charts where the annotations area is not directly
   * adjacent to the plot (e.g. an XY chart with a top axis), so the plot border
   * cannot serve as the separator.
   */
  outerBottomLine?: boolean;
}

export const AnnotationsConfigContext = createContext<AnnotationsContextProps>({
  showLabels: true,
  labelsWidth: DEFAULT_LABELS_OFFSET + DEFAULT_LABELS_WIDTH,
  trackWidth: 0,
  outerBottomLine: false,
});

AnnotationsConfigContext['displayName'] = 'AnnotationsConfig.Context';
